import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import {
  PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD,
  PHOTO_MANAGER_SUBSCRIPTION_FEATURES,
  PRO_PHOTO_MANAGER_SUBSCRIPTION_FEATURES,
} from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoManagerSubscriptionCheckout/helpers';
import { formatPriceForDisplay } from '../../../../util/format-money';
import Button from '../../../../components/global/Button';
import { BASENAME } from '../../../../constants/basenames';
import useBasename from '../../../../components/routing/useBasename';

const propTypes = {
  photoManagerSubscriptionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  skipFreeTrial: PropTypes.bool,
  isWaldoProFreeRegister: PropTypes.bool,
  setStartForFreeButtonClicked: PropTypes.func.isRequired,
};

const RegisterPhotoManagerForm = ({
  handleChange,
  photoManagerSubscriptionItems,
  handleSubmit,
  skipFreeTrial,
  isWaldoProFreeRegister,
  setStartForFreeButtonClicked,
}) => {
  const basename = useBasename();
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search);

  if (!photoManagerSubscriptionItems) {
    return null;
  }

  const yearlyPlan = photoManagerSubscriptionItems.find(
    item =>
      item.billing_period === PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD.YEARLY,
  );
  const suscriptionFeatures =
    basename === BASENAME.PRO || isWaldoProFreeRegister
      ? PRO_PHOTO_MANAGER_SUBSCRIPTION_FEATURES
      : PHOTO_MANAGER_SUBSCRIPTION_FEATURES;

  return (
    <div className="register-view-photo-manager-form">
      <ul className="photo-manager-subscription-features mb-0">
        {suscriptionFeatures.map(feature => (
          <li key={feature} className="text-dark">
            {feature}
          </li>
        ))}
      </ul>
      {yearlyPlan && isWaldoProFreeRegister && (
        <div className="my-2 text-center">
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'plan_id',
                  value: yearlyPlan.id,
                },
              });
              setStartForFreeButtonClicked(true);
              handleSubmit();
            }}
          >
            {isWaldoProFreeRegister
              ? 'Start 365-day free trial'
              : 'Get started for free!'}
          </Button>
        </div>
      )}
      {yearlyPlan && !isWaldoProFreeRegister && (
        <div className="my-2 text-center">
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'plan_id',
                  value: yearlyPlan.id,
                },
              });
              handleSubmit();
            }}
          >
            {skipFreeTrial ? (
              <p className="mb-0 text-center">
                ${formatPriceForDisplay(yearlyPlan.price.value, true)} / year
              </p>
            ) : (
              <p className="mb-0 text-center">
                Start {yearlyPlan.trial_days}&ndash;day free trial <br />
                <span className={skipFreeTrial ? undefined : 'text-normal'}>
                  (${formatPriceForDisplay(yearlyPlan.price.value, true)} / year
                  after trial ends)
                </span>
              </p>
            )}
          </Button>
        </div>
      )}
      {!isWaldoProFreeRegister && (
        <div className="text-center mt-2 text-md">
          Are you a pro photographer?{' '}
          <Button
            btnStyle="link"
            style={{ marginTop: '2px' }}
            btnSize="md"
            onClick={() =>
              history.replace({
                pathname: `/auth/register`,
                search: `?${qs.stringify({
                  ...(search ?? {}),
                  is_waldo_pro: true,
                  skip_free_trial: true,
                })}`,
              })
            }
          >
            Sign up here
          </Button>
        </div>
      )}
    </div>
  );
};

RegisterPhotoManagerForm.propTypes = propTypes;

export default RegisterPhotoManagerForm;
